/**
 * Frontend mirror of backend CommissionImportUploadMethod (cn/enums/CommissionImportUploadMethod.java).
 *
 * Ordinal order MUST match the backend declaration exactly — the column is persisted
 * @Enumerated(ORDINAL), so the ordinal number is what the DB stores and what QL filters must bind.
 * Append-only: new values may only be added at the end; existing ordinals must never be reordered
 * or removed.
 *
 *   LOCAL_AI_AGENT   → ordinal 0  — import is handled by a locally-running AI agent
 *   STRUCTURED_FILE  → ordinal 1  — import reads a structured file (CSV, XLSX, JSON, GDV, …)
 *   MANUAL           → ordinal 2  — data is entered manually by a user
 */
export enum CommissionImportUploadMethodEnum {
    LOCAL_AI_AGENT,
    STRUCTURED_FILE,
    MANUAL,
}

/**
 * German UI labels for CommissionImportUploadMethodEnum values.
 * Keyed by ordinal so label resolution is O(1) without string→enum conversion.
 */
export const CommissionImportUploadMethodLabels: Record<CommissionImportUploadMethodEnum, string> = {
    [CommissionImportUploadMethodEnum.LOCAL_AI_AGENT]: 'Lokaler KI-Agent',
    [CommissionImportUploadMethodEnum.STRUCTURED_FILE]: 'Strukturierte Datei',
    [CommissionImportUploadMethodEnum.MANUAL]: 'Manuell',
};
